import React from 'react'
import { Nav, Tab } from 'react-bootstrap'
import KPIList from './kpilist'
import KpiReport from './KpiReport'
import { useState } from 'react'
import { useEffect } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'


const KPI = () => {
    const [list , setList] = useState([]);
    const configData = useSelector(state => state.configSlice)
    const userData = useSelector(state => state.userSlice)
    const [loading, setLoading] = useState(true)
    
    const fetchKPIs = async () => {
        try {
            var {data } = await axios.get(`${configData.config.UNO_URL}/api/kpi/list/${userData.user.group.uuid}`,{
                headers: {
                    Authorization: `Bearer ${userData.token}`
                }});
            setList(data.data);
            setLoading(false)
        } catch (error) {
            console.log(error);
        }
    }
    
    useEffect(()=> {
        fetchKPIs();
    }, [])

    return (
        <>
        <Tab.Container defaultActiveKey="report">
            <Nav className='tabsproduct updated toptab ' variant="pills">
                <Nav.Item>
                    <Nav.Link eventKey="report">KPI Dashboard</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="list">Group KPIs</Nav.Link>
                </Nav.Item>
            </Nav>

            <div className='container-fluid p-2 px-3 bg-grey-main forkpi'>
            <Tab.Content className='groupuserscont  ps-2'>
                <Tab.Pane  eventKey="report">
                    <KpiReport list={list} loading={loading}/>
                </Tab.Pane>
                <Tab.Pane eventKey="list">
                    <KPIList fetchKPIs={fetchKPIs} list={list} loading={loading}/>
                </Tab.Pane>
            </Tab.Content>
        </div>
        </Tab.Container>
        </>
    )
}

export default KPI